import React, { useEffect } from 'react';
import {
    Button,
    Form,
    Input,
    Col,
    Row,
    Flex,
    DatePicker,
    Select,
    message,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import * as adminactions from "store/actions/AuthActions";
import dayjs from 'dayjs';


const LeadTaskForm = ({ leadId, tasks, setTasks, instance, form, reload }) => {

    const status_options = [
        { value: 'OPEN', label: 'OPEN' },
        { value: 'COMPLETED', label: 'COMPLETED' },
    ]

    // Map a DRF error body ({field: ["msg"]}) back onto the matching form fields.
    // Anything that isn't a known field falls back to a toast so the failure is
    // never silent.
    const applyApiErrors = (err, fallback) => {
        const data = err?.response?.data;
        const fieldNames = ['title', 'description', 'due_date', 'status', 'lead'];
        const fieldErrors = [];
        let otherMessages = [];

        if (data && typeof data === 'object' && !Array.isArray(data)) {
            Object.entries(data).forEach(([key, value]) => {
                const text = Array.isArray(value) ? value.join(' ') : String(value);
                if (fieldNames.includes(key)) {
                    fieldErrors.push({ name: key, errors: [text] });
                } else {
                    otherMessages.push(text);
                }
            });
        } else if (Array.isArray(data)) {
            otherMessages = data.map((item) => String(item));
        } else if (typeof data === 'string') {
            otherMessages = [data];
        }

        if (fieldErrors.length) form.setFields(fieldErrors);
        if (otherMessages.length) message.error(otherMessages.join(' '));
        else if (!fieldErrors.length) message.error(fallback);
    };

    const onFinish = async (values) => {
        try {
            if (instance) {
                const response = await adminactions.updateLeadTask({ ...values, lead: leadId }, instance.id);
                const restTasks = tasks.filter((task) => task.id !== response.data['id'])
                setTasks([...restTasks, response.data])
                reload();
            } else {
                const response = await adminactions.addLeadTask({ ...values, lead: leadId });
                setTasks((tasks) => [...tasks, response.data])
                reload();
            }
        } catch (err) {
            applyApiErrors(err, `Failed to ${instance ? 'update' : 'create'} task`);
        }
    };

    useEffect(() => {
        if (instance) {
            const thisInstance = { ...instance }
            let date_fields = ['due_date']
            for (let field of date_fields) {
                thisInstance[field] = thisInstance[field] ? dayjs(thisInstance[field]) : null;
            }
            form.setFieldsValue(thisInstance);
        }
    }, [instance])

    return (
        <Form
            form={form}
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 18 }}
            onFinish={onFinish}
        >
            <Row style={{ margin: "15px" }}>
                <Col span={24} style={{}}>
                    <div className="site-card-border-less-wrapper">
                        <div>
                            <Form.Item label="Lead" name='lead' hidden>
                                <Input defaultValue={leadId} />
                            </Form.Item>
                            <Form.Item label="Title" name='title' rules={[{ required: true, message: 'Please enter a title' }]}>
                                <Input />
                            </Form.Item>
                            <Form.Item label="Description" name='description'>
                                <TextArea />
                            </Form.Item>
                            <Form.Item label="Due Date" name="due_date" rules={[{ required: true, message: 'Please select a due date' }]}>
                                <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" />
                            </Form.Item>
                            <Form.Item label="Status" name='status' rules={[{ required: true, message: 'Please select a status' }]}>
                                <Select
                                    placeholder="Select Status"
                                    options={status_options}
                                />
                            </Form.Item>
                            {/* <Form.Item label="Assigned To" name='assigned_to' rules={[{ required: true }]}>
                                <Select
                                    placeholder="Select User"
                                    options={}
                                />
                            </Form.Item> */}
                        </div>
                        <Flex justify='flex-end'>
                            <Button block type="primary" htmlType="submit" style={{ maxWidth: 100 }} >
                                Save
                            </Button>
                        </Flex>
                    </div>
                </Col>
            </Row>
        </Form>
    );
};
export default LeadTaskForm;